import { Component, OnInit, Input, ChangeDetectionStrategy, Output, EventEmitter, ViewChild } from '@angular/core';
import { GlobalService } from '../../shared/services/global.service';

@Component({
    selector: 'app-milestone-table',
    templateUrl: './milestone-table.component.html',
    styleUrls: ['./milestone-table.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MilestoneTableComponent implements OnInit {
	@Input() list: any;
	@Input() weeks: number = 20;
	@Output() contextClick = new EventEmitter<string>();

	viewbox: string = "0 0 1500 1000"
	screenviewbox: string = "0 0 1500 1000"
	svgwidth: string = '1500px';
	viewboxWhide = 1500
	viewboxheigth = 1000
	labelWidth = 300
	scrollPositionX = 0
	scrollPositionY = 0

	selectMilestone(ev) {
		this.contextClick.emit(ev)
	}
	checkDay(ev) {
		var a = ['M', 'T', 'W', 'T', 'F', 'S', 'S']
		return a[ev]
	}
	checkY(item, position) {
		var b = 0
		var i = position
		if (position > 0) {
			// var a = this.list[position - 1]
			while (i > 0) {
				b = b + (this.list[i - 1].childs && !this.list[i - 1].hideChilds ? this.list[i - 1].childs.length : 0);
				i = i - 1
			}
		}
		return 50 + ((position + b) * 30)
	}
	checkTypeDuration(ev) {
		if (ev == 1) {
			return "D"
		} else {
			return "W"
		}
	}
	arrayOf(itm) {
		return Array(itm)
	}
	checkX(itm) {
		if (itm.parent_id) {
			return 20
		} else {
			return 0
		}
	}
	checkBoxStart(itm) {
		return 30 * itm.real_start
	}
	checkBoxWidth(itm) {
		return 30 * itm.real_duration
	}
	checkWidth(itm) {
		if (itm.parent_id) {
			return this.labelWidth - 20
		} else {
			return this.labelWidth
		}
	}
	checkBackground(itm) {
		if (itm.parent_id) {
			return 'white'
		} else {
			return itm.color_code
		}
	}

	constructor(private _gS: GlobalService) { }

	ngOnInit() {
		this.svgwidth = (this.labelWidth + 10 + ((this.weeks * 7) * 30)) + 'px'
		this.viewboxWhide = this.labelWidth + 10 + ((this.weeks * 7) * 30)
		this.viewbox = "0 0 " + this.viewboxWhide + " " + this.viewboxheigth
		this.screenviewbox = "0 0 " + "1600" + " " + this.viewboxheigth
		var elmnt = document.getElementById("myDIV");
		elmnt.addEventListener('scroll', e => {
			// this.scrollPositionX = e.srcElement.scrollLeft
			// this.scrollPositionY = e.srcElement.scrollTop
		});
	}

}
